import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { connect } from '../../../../../../../redux/connect';
import { setQueryParamsAction } from '../../../../../../../redux/actions';
import { getQueryParams, getOxygenMappings } from '../../../../../../../redux/selectors';
import { queryParamsType } from '../../../../../../../constants/proptype-validation';
import T from 'i18n-react';
import { SelectDropdown } from '@adsk/bim360-matrix-react-components';
import { SORTING_PARAMS, PAGE_PARAMS } from '../../../../../../../constants/issue-query-params';
import { getPreloadedSortQueryParamsState } from '../../../../../../../constants/preloaded-states';

export class PureSort extends PureComponent {

  static displayName = 'Sort';

  static propTypes = {
    disabled: PropTypes.bool.isRequired,
    setQueryParamsAction: PropTypes.func.isRequired,
    queryParams: queryParamsType.isRequired,
    onLabelClick: PropTypes.func.isRequired,
    displaySortDropdown: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.generalRawOptions = [
      { id: '-created_at', text: T.translate('sort.creationDateDescending'), title: T.translate('sort.creationDate') },
      { id: 'created_at', text: T.translate('sort.creationDateAscending'), title: T.translate('sort.creationDate') },
      { id: 'status', text: T.translate('sort.statusAscending'), title: T.translate('sort.status') },
      { id: '-status', text: T.translate('sort.statusDescending'), title: T.translate('sort.status') },
      { id: 'due_date', text: T.translate('sort.dueDateAscending'), title: T.translate('sort.dueDate') },
      { id: '-due_date', text: T.translate('sort.dueDateDescending'), title: T.translate('sort.dueDate') },
      { id: 'title', text: T.translate('sort.titleAscending'), title: T.translate('sort.title') },
      { id: '-title', text: T.translate('sort.titleDescending'), title: T.translate('sort.title') },
    ];

    const sortOptions = this.getOptions();
    const currentSorting = sortOptions.find(option => option.value === this.props.queryParams[SORTING_PARAMS.SORT]);
    const labelDisplayText = !currentSorting || currentSorting.value === getPreloadedSortQueryParamsState()[SORTING_PARAMS.SORT] ? T.translate('sort.sort') : currentSorting.labelDisplayText;

    this.state = {
      labelDisplayText,
      sortOptions,
    };
    this.handleSortChange = this.handleSortChange.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const newState = {};

    if (this.props.queryParams[SORTING_PARAMS.SORT] !== nextProps.queryParams[SORTING_PARAMS.SORT]) {
      const sortOptions = this.state.sortOptions;
      const currentSorting = sortOptions.find(option => option.value === nextProps.queryParams[SORTING_PARAMS.SORT]);
      newState.labelDisplayText = currentSorting ? currentSorting.labelDisplayText : T.translate('sort.sort');
    }

    this.setState(newState);
  }

  handleSortChange(event) {
    const { setQueryParamsAction } = this.props;
    const { labelDisplayText } = event;
    this.setState({ labelDisplayText });
    setQueryParamsAction({ [SORTING_PARAMS.SORT]: event.value, [PAGE_PARAMS.OFFSET]: 0 });
  }

  getOptions() {
    const rawOptions = this.generalRawOptions;
    const options = [];

    rawOptions.map((option) => {
      return (
        options.push({
          hideTitle: true,
          value: option.id,
          label: option.text,
          labelDisplayText: `${T.translate('sort.sortingBy')} ${option.title} ${option.onlyAscending ? '' : option.id[0] === '-' ? '\u2193' : '\u2191'}`,
        })
      );
    });
    return options;
  }

  renderDropdown() {
    const { disabled, queryParams, displaySortDropdown } = this.props;

    return (
      <SelectDropdown
        selectedOptions={this.state.sortOptions.find(option => option.value === queryParams[SORTING_PARAMS.SORT])}
        valueRenderer={() => ''}
        placeholder={''}
        searchPlaceholder={''}
        options={this.state.sortOptions}
        disabled={disabled}
        onChange={this.handleSortChange}
        onClose={() => displaySortDropdown(false)}
        onOpen={() => displaySortDropdown(true)}
      />
    );
  }

  render() {
    const { onLabelClick, isOpen } = this.props;
    const { labelDisplayText } = this.state;
    const sortToggleButtonClass = cx('isui-filter-sort__show-sort', {
      'isui-filter-sort__show-sort--open': isOpen,
    });
    return (
      <div className="isui-sort-wrapper">
        <span className={sortToggleButtonClass} onClick={onLabelClick}>{labelDisplayText}</span>
        <div className="Sort">
          {this.renderDropdown()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  queryParams: getQueryParams(state),
  oxygen: getOxygenMappings(state),
});

export default connect(mapStateToProps, {
  setQueryParamsAction,
})(PureSort);
